import { Link, Outlet, useMatches } from "react-router";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Benefits } from "~/features/benefits/Benefits";
import { LanddingBoxContainer } from "~/features/landing/LanddingBoxContainer";
import { PublicFooter } from "~/features/public/Footer";
import { NavBar } from "~/features/public/NavBar";

export const handle = {
  pharmacySection: true,
};

export default function Index() {
  const matches = useMatches();
  const isPharmacySectionIndex = matches[matches.length - 1]?.pathname === "/register/pharmacy";
  const isLoggedIn: boolean = (matches[0]?.data as any)?.loggedIn ?? false;
  const { t } = useTranslation();

  const right = isLoggedIn ? (
    <Link
      className="inline-flex items-center justify-center gap-1 rounded-xl bg-blue-550 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-blue-800/20 transition hover:-translate-y-0.5 hover:bg-blue-900"
      to="/client/dashboard"
    >
      {t("Startseite")}
      <ArrowRight className="w-5" />
    </Link>
  ) : (
    <Link
      className="inline-flex items-center justify-center gap-1 rounded-xl bg-blue-550 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-blue-800/20 transition hover:-translate-y-0.5 hover:bg-blue-900"
      to="/v1/auth/login"
    >
      {t("Login")}
      <ArrowRight className="w-5" />
    </Link>
  );

  return (
    <div className="bg-gray-100">
      <div className="md:h-30 h-28">
        <NavBar logoTo="/" navItems={[]} right={right} />
      </div>
      <LanddingBoxContainer>{isPharmacySectionIndex ? null : <Outlet />}</LanddingBoxContainer>
      <div className="public-container">
        <Benefits />
      </div>
      <PublicFooter />
    </div>
  );
}
